import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "serp__filter-dropdown-list--container q-container-fluid q-pb-2 q-d-flex"
}
const _hoisted_2 = { class: "serp__filter-dropdown-list q-justify-content-start q-d-flex q-flex-wrap q-col-12" }

import { computed, inject, ref, watch, unref } from 'vue'
import FilterDropdown from "@/components/SerpPage/FiltersContainer/FiltersList/FilterDropdown.vue";
import ClearFiltersButton from "@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButton.vue"
import SortingButtonDropDown from "@/components/SerpPage/ResultsContainer/ButtonsContainer/SortingButtonDropDown.vue"
import {storeToRefs} from "pinia";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import { CustomSmartSearchLabels, SmartSearchTranslationsInterface } from '@/core/types'
import { resolveCustomSmartSearchConfig } from '@/core/customSmartSearchConfig'


export default /*@__PURE__*/_defineComponent({
  __name: 'FiltersDropdownsList',
  setup(__props) {

const filtersStore = useFiltersStore();
const {getFilters} = storeToRefs(filtersStore)
const serpStore = useSerpResultsStore();
const {noResultsState} = storeToRefs(serpStore)

const SmartSearchTranslations = inject('SmartSearchTranslations') as any
const customLabels = (typeof window !== 'undefined'
  ? (window as any)?._QONizer?.customSmartSearchConfig?.labels
  : undefined) as CustomSmartSearchLabels | undefined
const { accordionVisibleItemsLimit } = resolveCustomSmartSearchConfig()
const showAllFilters = ref(false)

const checkboxFiltersCount = computed(() => {
  return getFilters.value.reduce((count, filter) => {
    return filter.type === 'checkbox' ? count + 1 : count
  }, 0)
})

const shouldDisplayToggleButton = computed(() => {
  return accordionVisibleItemsLimit > 0 && checkboxFiltersCount.value > accordionVisibleItemsLimit
})

const displayedFilters = computed(() => {
  if (!shouldDisplayToggleButton.value || showAllFilters.value) {
    return getFilters.value
  }

  let includedCheckboxes = 0

  return getFilters.value.filter((filter) => {
    if (filter.type !== 'checkbox') {
      return true
    }

    if (includedCheckboxes < accordionVisibleItemsLimit) {
      includedCheckboxes += 1
      return true
    }

    return false
  })
})

watch(shouldDisplayToggleButton, (enabled) => {
  if (!enabled) {
    showAllFilters.value = false
  }
})

const normalizeLabel = (label: unknown): string | undefined => {
  if (typeof label !== 'string') {
    return undefined
  }

  const trimmed = label.trim()
  return trimmed || undefined
}

function getShowAllFiltersLabel(): string {
  const customLabel = normalizeLabel(customLabels?.filters?.showAllFilters)
  if (customLabel) {
    return customLabel
  }

  const label = normalizeLabel(unref(SmartSearchTranslations)?.filters?.showAllFilters)
  return label || 'Pokaż wszystkie filtry'
}

function getHideFiltersLabel(): string {
  const customLabel = normalizeLabel(customLabels?.filters?.hideFilters)
  if (customLabel) {
    return customLabel
  }

  const label = normalizeLabel(unref(SmartSearchTranslations)?.filters?.hideFilters)
  return label || 'Ukryj filtry'
}

const toggleButtonLabel = computed(() => showAllFilters.value ? getHideFiltersLabel() : getShowAllFiltersLabel())

function toggleFiltersVisibility() {
  showAllFilters.value = !showAllFilters.value
}

return (_ctx: any,_cache: any) => {
  return (!_unref(noResultsState))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_unref(noResultsState))
            ? (_openBlock(), _createBlock(SortingButtonDropDown, { key: 0 }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedFilters.value, (filter) => {
            return (_openBlock(), _createBlock(FilterDropdown, {
              key: filter.field,
              filter: filter
            }, null, 8, ["filter"]))
          }), 128)),
          (shouldDisplayToggleButton.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "serp__filters-toggle-button serp__filters-toggle-button--dropdown",
                onClick: toggleFiltersVisibility
              }, _toDisplayString(toggleButtonLabel.value), 1))
            : _createCommentVNode("", true),
          _createVNode(ClearFiltersButton)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})